<template>
  <div class="float-msg">
    <span class="float-interval">{{ selInterval }}</span>
    <span class="float-duration">{{ selDuration }}</span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  computed: {
    selInterval() {
      let start = this.selectStart;
      let end = this.selectEnd;
      if (start > end) {
        [start, end] = [end, start];
      }
      return (
        moment(start).format("HH:mm") +
        "~" +
        moment(end + this.setting.block.size * 60 * 1000).format("HH:mm")
      );
    },
    selDuration() {
      let start = this.selectStart;
      let end = this.selectEnd;
      if (start > end) {
        [start, end] = [end, start];
      }
      end += this.setting.block.size * 60 * 1000;
      const duration = (end - start) / 1000 / 60;
      const hours = Math.floor(duration / 60);
      const minutes = duration % 60;
      const hourStr = hours ? hours + "小时" : "";
      const minuteStr = minutes ? minutes + "分钟" : "";

      return hourStr + minuteStr;
    },
    ...mapGetters(["selectStart", "selectEnd", "setting"])
  }
};
</script>
<style>
.float-msg {
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  background-color: #f6ffed;
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  padding: 1rem;
}

.float-msg .float-interval {
  display: block;
}
</style>
